import { render, staticRenderFns } from "./selfService.vue?vue&type=template&id=2ca699da&"
import script from "./selfService.vue?vue&type=script&lang=ts&"
export * from "./selfService.vue?vue&type=script&lang=ts&"
import style0 from "./selfService.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports